export const heatmap_layer_names = {
  count_gas_station: 'Количество АЗС',
  count_parking: 'Количество парковок',
  count_tech_services: 'Количество СТО',
  max_traffic_level: 'Максимальный уровень пробок',
  count_dosug: 'Досуг, туризм и проживание',
  count_health_beauty: 'Здоровье и красота',
  count_non_commercial_org: 'Некоммерческие организации',
  count_food_drink: 'Еда и напитки',
  count_services_for_people: 'Услуги для населения',
  count_retail: 'Розничная торговля',
  count_industry: 'Промышленность, строительство и B2B',
  count_finance: 'Финансы, право и страхование',
  count_education: 'Образование (коммерческое)',
  count_auto: 'Авто и транспорт',
  hhi: 'Разнообразие бизнеса',
};
